(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.addEventListener('scroll', function () {
    document.documentElement.classList.toggle('gs-scrolled', window.scrollY > 8);
  }, { passive: true });
  if (reduce || !('IntersectionObserver' in window)) return;
  function init() {
    var sel = '.gs-section__head,.gs-card,.gs-cat,.gs-why__card,.gs-trust__item,.gs-faq__item,.gs-spot__media,.gs-assure';
    var els = [].slice.call(document.querySelectorAll(sel));
    if (!els.length) return;
    document.documentElement.classList.add('gs-motion');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('gs-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (el) {
      var i = el.parentElement ? [].indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--gs-d', Math.min(i, 7) * 70 + 'ms');
      el.classList.add('gs-rv');
      io.observe(el);
    });
    setTimeout(function () { els.forEach(function (el) { el.classList.add('gs-in'); }); }, 5000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
